<div class="pb-xl">
    <app-enter-your-information
        class="mb-lg block"
        [showClientInfoPageTitle]="false"
        [showLoginSection]="false"
        [canShowPasswordField]="showPassword"
    ></app-enter-your-information>
    <button
        id="review-details"
        hlmBtn
        class="w-full"
        (click)="actionButtonText === 'Create Account' ? onReviewDetails() : onContinue()"
        [disabled]="enterYourInformationComponent?.formGroup?.invalid || isSaving"
    >
        <ng-container *ngIf="!isSaving">{{ actionButtonText }}</ng-container>
        <hlm-spinner *ngIf="isSaving" style="margin: auto" class="size-6"></hlm-spinner>
    </button>
</div>
